"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryPickupPlannedStopUpdate = exports.DeliveryPickupPlannedStopCreate = exports.DeliveryPickupPlannedStopQuery = exports.DeliveryPickupPlannedStopTransport = exports.DeliveryPickupPlannedStop = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const enums_1 = require("../enums");
const SubscriptionEquipment_1 = require("../subscriptions-and-billing/SubscriptionEquipment");
const DeliveryPickupRouteBreadcrumb_1 = require("./DeliveryPickupRouteBreadcrumb");
const DeliveryPickupRouteEvent_1 = require("./DeliveryPickupRouteEvent");
exports.DeliveryPickupPlannedStop = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    deliveryPickupRouteID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })), // These can be created without a route for later assignment.
    status: enums_1.DeliveryPickupPlannedStopStatus,
    events: typebox_1.Type.Array(DeliveryPickupRouteEvent_1.DeliveryPickupRouteEvent),
    equipment: typebox_1.Type.Array(SubscriptionEquipment_1.SubscriptionEquipment),
    stopType: enums_1.StopType,
    deliveryPickupBreadcrumbs: typebox_1.Type.Array(DeliveryPickupRouteBreadcrumb_1.DeliveryPickupRouteBreadcrumb),
    driversActiveStop: typebox_1.Type.Boolean(),
    ordinal: typebox_1.Type.Integer({ minimum: 0 }),
    serviceLocation: typebox_1.Type.Optional(common_1.ServiceLocationTransport),
    placementNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: common_1.MetaData,
    date: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
});
exports.DeliveryPickupPlannedStopTransport = exports.DeliveryPickupPlannedStop;
exports.DeliveryPickupPlannedStopQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        orphaned: typebox_1.Type.Boolean(),
        customerID: typebox_1.Type.String({ format: 'uuid' }),
        deliveryPickupRouteID: typebox_1.Type.String({ format: 'uuid' }),
        hasEvent: typebox_1.Type.Boolean(),
        eventIDs: typebox_1.Type.String({ description: 'Comma-separated list of event IDs' }),
        hasBreadcrumb: typebox_1.Type.Boolean(),
        deliveryPickupBreadcrumbIDs: typebox_1.Type.String({ description: 'Comma-separated list of breadcrumb IDs' }),
        beforeDate: typebox_1.Type.String({ format: 'date' }),
        afterDate: typebox_1.Type.String({ format: 'date' }),
        date: typebox_1.Type.String({ format: 'date' }),
    }),
]));
exports.DeliveryPickupPlannedStopCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.DeliveryPickupPlannedStop, [
        'id',
        'haulerID',
        'deliveryPickupRouteID', // Assign routes from the route's side. Not here.
        'events',
        'equipment',
        'deliveryPickupBreadcrumbs',
        'driversActiveStop', // Must be false on create, so no need to pass it up here.
        'ordinal', // Set this from the route's side. Not here. Default to 0.
        'status', // Derived
        'metadata',
    ]),
    typebox_1.Type.Object({
        equipmentIDs: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
        notes: (0, common_1.Nullable)(typebox_1.Type.Optional(typebox_1.Type.String())),
        date: (0, common_1.Nullable)(typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' }))),
    }),
]);
exports.DeliveryPickupPlannedStopUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.DeliveryPickupPlannedStop, [
        'id',
        'haulerID',
        'deliveryPickupRouteID', // Assign routes from the route's side. Not here.
        'events',
        'equipment',
        'deliveryPickupBreadcrumbs',
        'ordinal', // Set this from the route's side. Not here.
        'notes',
        'status', // Derived
        'metadata',
    ]),
    typebox_1.Type.Object({
        equipmentIDs: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
        notes: (0, common_1.Nullable)(typebox_1.Type.Optional(typebox_1.Type.String())),
        date: (0, common_1.Nullable)(typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' }))),
    }),
]));
//# sourceMappingURL=DeliveryPickupPlannedStop.js.map